import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

const FIVE_HOURS_MS = 5 * 60 * 60 * 1000;

const useQRManager = (userID) => {
  const { baseUrl, basicAuth } = useContext(GlobalContext);

  const config = {
    headers: {
      Authorization: basicAuth,
      "Content-Type": "application/json",
    },
  };

  const [qrCode, setQrCode] = useState("");
  const [qrLoading, setQrLoading] = useState(false);
const [topupLoading, setTopupLoading] = useState(false);

  // ── Fetch main QR Code ──────────────────────────────────
  useEffect(() => {
    if (!userID) return;

    const fetchQR = async () => {
      try {
        const res = await axios.post(
          `${baseUrl}/Whatsapp/getQRCode`,
          { userid: userID },
          config
        );

        if (res.data.responseCode === "00") {
          setQrCode(res.data.response.qr_image_url);
        }
      } catch (err) {
        console.error("QR Code Error:", err);
      }
    };

    fetchQR();
  }, [userID]);

  // ── Volunteer QR — auto load from session or generate ──
  useEffect(() => {
    if (!userID) return;

    const savedLink = sessionStorage.getItem(`qr_token_link_${userID}`);
    const lastCall = sessionStorage.getItem(`qr_token_last_call_${userID}`);

    if (lastCall) {
      const elapsed = Date.now() - Number(lastCall);
      if (elapsed < FIVE_HOURS_MS) {
        return;
      }
    }

    const autoGenerate = async () => {
      setQrLoading(true);
      try {
        const res = await axios.post(
          `${baseUrl}/User/v1.0/generateToeknForQRGeneration`,
          { shopCode: userID },
          config
        );

        if (res.data.responseCode === "00") {
          const link = res.data.data.link;
          sessionStorage.setItem(`qr_token_link_${userID}`, link);
          sessionStorage.setItem(`qr_token_last_call_${userID}`, Date.now().toString());
        }
      } catch (err) {
        console.error("Volunteer QR Auto-generate Error:", err);
      } finally {
        setQrLoading(false);
      }
    };

    autoGenerate();
  }, [userID]);

const addTopUp = async ({
  userId,
  amount,
  mobile,
  name,
}) => {
  if (!amount || Number(amount) <= 0) {
    toast.error("Enter valid amount");
    return;
  }

  try {
    setTopupLoading(true);

    const res = await axios.post(
      `${baseUrl}/Order/generatePaytmIntentAbhi`,
      {
        userid: userId,
        amount: amount,
        custMobile: mobile,
        custName: name || mobile || "Customer",
      },
      config
    );

    if (res?.data?.responseCode === "00") {
      const paymentUrl = res.data.link;

      if (!paymentUrl) {
        toast.error("Payment URL not received");
        return;
      }

      // 👉 open payment page
      window.open(paymentUrl, "_blank");

      return true;
    } else {
      toast.error(res.data.responseMessage);
      return false;
    }
  } catch (err) {
    console.error("TopUp Error:", err);
    toast.error("TopUp failed");
    return false;
  } finally {
    setTopupLoading(false);
  }
};

  return {
    qrCode,
    qrLoading,
    addTopUp,
  topupLoading,
  };
};

export default useQRManager;